import { gql } from "@apollo/client";

export const CREATE_CHECKOUT = gql`
	mutation CreateCheckout($checkout: UpdateCartInput!) {
		updateCart(input: $checkout) {
			checkout {
				id
				customerId
				shippingAddressId
				checkoutLineItems {
					nodes {
						id
						variant {
							sku
						}
					}
				}
			}
		}
	}
`;

export const UPDATE_CHECKOUT = gql`
	mutation UpdateCheckout($checkout: UpdateCheckoutInput!) {
		updateCheckout(input: $checkout) {
			shippingRate {
				id
				price
				serviceId
				serviceType
				deliveryMethodDefinitionId
				title
			}
		}
	}
`;

export const GET_CHECKOUT = gql`
	query GetCheckout($checkoutId: UUID!) {
		checkout(id: $checkoutId) {
			email
			customerId
			step
			subtotalPrice
			totalTax
			totalDiscounts
			totalPrice
			shippingRate {
				id
				price
				serviceId
				serviceType
				deliveryMethodDefinitionId
				title
			}
			shippingAddress {
				id
				firstName
				lastName
				dateOfBirth
				phone
				addressLine1
				addressLine2
				city
				stateId
				countryId
				zipCode
			}
			checkoutLineItems {
				nodes {
					id
					variant {
						sku
					}
				}
			}
		}
	}
`;
